import Form from "@/shared/form/form";
import { CompanyDocumentReadConfirmationType } from "gql/graphql";

export function useReadConfirmationTypeGuard({
  initialType,
  hasConfirmations,
}: {
  initialType?: CompanyDocumentReadConfirmationType;
  hasConfirmations: boolean;
}) {
  const form = Form.useFormInstance();
  const current = Form.useWatch("readConfirmationType", form) as
    | CompanyDocumentReadConfirmationType
    | undefined;

  const needsWarning =
    hasConfirmations && !!initialType && !!current && current !== initialType;

  return { needsWarning };
}
